'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareDock = function HardwareDock(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z' })
  );
};
HardwareDock = (0, _pure2.default)(HardwareDock);
HardwareDock.displayName = 'HardwareDock';
HardwareDock.muiName = 'SvgIcon';

exports.default = HardwareDock;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/hardware/dock.js
// module id = 3016
// module chunks = 0